import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const testimonials = [
  {
    id: 1,
    name: "Dr Jyoti Jha",
    role: "Medical Professional",
    content:
      "Excellent experience. Excellent aura. Correctly named. Positive atmosphere. Would recommend everyone. It's very important to give at least one hour to yourself, and here you will fall in self-love.",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocLTAgM-oa5l1ShkVyfgNoVATD7mxIQyekU1Svy-l-8KxnjEkQ=s64-c-rp-mo-br100",
    rating: 5,
  },
  {
    id: 2,
    name: "Sai Nishant",
    role: "Wellness Seeker",
    content:
      "People searching for a path to self-discipline, good health and inner peace - your journey starts here!",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocKF7kvIgZvboL9MG9_9g35VEjwDRIXhaMrQ9EPJDFvmw-W41w=s64-c-rp-mo-ba2-br100",
    rating: 5,
  },
  {
    id: 3,
    name: "Jasminder Bhatia",
    role: "Regular Member",
    content:
      "I joined yoga one month back. My body was totally stiff, not able to even bend properly. I really feel the change in my body. I am very much confident now. Really thanks to Ms. Karuna, our instructor. She is very polite, cooperative, and understanding.",
    avatar:
      "https://lh3.googleusercontent.com/a/ACg8ocJNEc3n2RfVdPgro0Qf3rAgqvcpynggQju7bM9D8eYQ2lX3lQ=s64-c-rp-mo-br100",
    rating: 5,
  },
];

export default function Testimonials() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section
      id="testimonials"
      className="py-20 lg:py-32 relative overflow-hidden bg-gradient-to-br from-sage-50 via-earth-50 to-white"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-sage-200 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-earth-200 rounded-full blur-3xl opacity-20"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -70 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
            }}
            className="flex-1"
          >
            <span className="inline-block px-4 py-2 bg-sage-100 text-sage-700 rounded-full text-sm font-semibold mb-4">
              Testimonials
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Our Customers{" "}
              <span className="gradient-text">Love What We Do</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Over 100 people are with us in making their lives more meaningful,
              healthy, and balanced. Read what they have to say about their
              transformation journey.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="text-3xl font-bold gradient-text mb-2">
                  100+
                </div>
                <div className="text-gray-600 text-sm">Happy Members</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="text-3xl font-bold gradient-text mb-2">
                  5.0 ⭐
                </div>
                <div className="text-gray-600 text-sm">Average Rating</div>
              </div>
            </div>

            <a
              href="https://www.google.com/search?q=aura+yog+centre+shalimar+bagh&rlz=1C1RXQR_enIN1086IN1086&oq=aura+yog+centre+shalimar+bagh&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBCDc4NzhqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8#lrd=0x390d03d05b647191:0x5692ad546e05293,1,,,,"
              target="_blank"
              rel="noreferrer"
              className="btn-secondary inline-block"
            >
              Read All Reviews on Google
            </a>
          </motion.div>

          {/* Right Content - Testimonials */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: 70 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
            }}
            className="flex-1"
          >
            <div className="space-y-6">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={testimonial.id}
                  initial={{ opacity: 0, y: 30 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.2,
                  }}
                  className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  {/* Quote Icon */}
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-sage-400 to-teal-400 flex items-center justify-center flex-shrink-0">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      {/* Stars */}
                      <div className="flex gap-1 mb-2">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <svg
                            key={i}
                            className="w-5 h-5 text-yellow-400 fill-current"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                          </svg>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <p className="text-gray-600 leading-relaxed mb-6 italic">
                    "{testimonial.content}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-4">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover ring-4 ring-sage-100"
                    />
                    <div>
                      <div className="font-bold text-gray-900">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-gray-500">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
